var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) { ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconAddress(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 20,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7 .625a6.25 6.25 0 00-6.25 6.25C.75 12.5 7 19.063 7 19.063s6.25-6.563 6.25-12.188A6.25 6.25 0 007 .625v0z",
    stroke: "#000064",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7 9.375a2.5 2.5 0 100-5 2.5 2.5 0 000 5z",
    stroke: "#000064",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTQiIGhlaWdodD0iMjAiIHZpZXdCb3g9IjAgMCAxNCAyMCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4NCjxwYXRoIGQ9Ik03IDAuNjI1QzUuMzQyNCAwLjYyNSAzLjc1MjY5IDEuMjgzNDggMi41ODA1OCAyLjQ1NTU4QzEuNDA4NDggMy42Mjc2OSAwLjc1IDUuMjE3NCAwLjc1IDYuODc1QzAuNzUgMTIuNSA3IDE5LjA2MjUgNyAxOS4wNjI1QzcgMTkuMDYyNSAxMy4yNSAxMi41IDEzLjI1IDYuODc1QzEzLjI1IDUuMjE3NCAxMi41OTE1IDMuNjI3NjkgMTEuNDE5NCAyLjQ1NTU4QzEwLjI0NzMgMS4yODM0OCA4LjY1NzYgMC42MjUgNyAwLjYyNVYwLjYyNVoiIHN0cm9rZT0iIzAwMDA2NCIgc3Ryb2tlLXdpZHRoPSIxLjUiIHN0cm9rZS1taXRlcmxpbWl0PSIxMCIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+DQo8cGF0aCBkPSJNNyA5LjM3NUM4LjM4MDcxIDkuMzc1IDkuNSA4LjI1NTcxIDkuNSA2Ljg3NUM5LjUgNS40OTQyOSA4LjM4MDcxIDQuMzc1IDcgNC4zNzVDNS42MTkyOSA0LjM3NSA0LjUgNS40OTQyOSA0LjUgNi44NzVDNC41IDguMjU1NzEgNS42MTkyOSA5LjM3NSA3IDkuMzc1WiIgc3Ryb2tlPSIjMDAwMDY0IiBzdHJva2Utd2lkdGg9IjEuNSIgc3Ryb2tlLW1pdGVybGltaXQ9IjEwIiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiLz4NCjwvc3ZnPg0K";
export { SvgIconAddress as ReactComponent };